// ANGULAR -------------------------------------------------------------------
import { ApplicationConfig, isDevMode } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAuth, LogLevel, authInterceptor } from "angular-auth-oidc-client";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";

//PRIME NG -------------------------------------------------------------------
import { MessageService } from "primeng/api";

// CUSTOM --------------------------------------------------------------------

import { routes } from "@shared/routes/app.routes";
import { environment } from "@environments/environment";
import { headerInterceptor } from "@core/functions/header-interceptor";
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideAnimations(),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor(), headerInterceptor])),
    provideAuth({
        config: {
            authority: environment.adfsAuthority,
            redirectUrl: `${window.location.origin}/redirect`,
            postLoginRoute: `${window.location.origin}/redirect`,
            postLogoutRedirectUri: window.location.origin,
            clientId: environment.clientId,
            secureRoutes: [environment.myTripApiUrl, environment.imaxApiUrl],
            scope: "openid",
            autoUserInfo: false,
            responseType: "id_token token",
            silentRenew: true,
            silentRenewUrl: `${window.location.origin}/silent-refresh.html`,
            logLevel: LogLevel.Debug,
        },
    }),
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    })
],
};
